import script from "./AutomazioniAi.vue?vue&type=script&setup=true&lang=js"
export * from "./AutomazioniAi.vue?vue&type=script&setup=true&lang=js"

import "./AutomazioniAi.vue?vue&type=style&index=0&id=48e982bb&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-48e982bb"]])

export default __exports__